export const enum SnContentType {
  Camera = 'Camera',
  Layer = 'Layer',
  Location = 'Location',
  Grid = 'CameraView',
  Tag = 'Tag',
  Team = 'Team',
  User = 'User',
  Alarm = 'Alarm',
  Tip = 'Tip',
  Recording = 'Recording',
  GooglePlace = 'Google Place',
  GoogleAddress = 'Google Address',
  Avl = 'avl',
  Cad = 'cad',
  MapViews = 'Map Views',
  Hotlists = 'Hotlists',
  Registrant = 'Registrant',
  Disclaimer = 'Disclaimer',
  FedexAsset = 'FedEx Asset',
}
